import { Delete, Pencil } from '@factorialco/f0-react/icons/app'
import { format } from 'date-fns'
import { DealDetailsQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { ResourceHeadersPropsWithActions } from 'modules/core/lib/navigation/types'

import { dealStatusAsVariant, dealTranslateStatus } from 'modules/finance/components/Deals/utils'
import { contactFullName } from 'modules/finance/lib/contactsUtils'

export function buildDealHeaderProps(data: DealDetailsQuery): ResourceHeadersPropsWithActions {
  const deal = data?.finance.deal

  if (!deal) {
    return { title: i18n.t('finance.deals.details.title') }
  }

  const secondaryActions = [
    {
      label: i18n.t('finance.deals.actions.edit'),
      icon: Pencil,
      key: 'edit-deal',
    },
  ]

  const otherActions = [
    {
      label: i18n.t('finance.deals.actions.delete'),
      icon: Delete,
      critical: true,
      key: 'delete-deal',
    },
  ]

  return {
    title: deal.name,
    description: i18n.t('finance.deals.details.subtitle'),
    status: {
      label: i18n.t('finance.deals.details.stage'),
      text: dealTranslateStatus(deal.stage),
      variant: dealStatusAsVariant(deal.stage),
    },
    metadata: [
      {
        label: i18n.t('finance.deals.details.client'),
        value: {
          type: 'avatar',
          text: contactFullName(deal.client),
          variant: {
            type: 'company',
            name: contactFullName(deal.client),
          },
        },
      },
      {
        label: i18n.t('finance.deals.details.created_at'),
        value: {
          type: 'text',
          content: deal.createdAt ? format(new Date(deal.createdAt), 'PPP') : '-',
        },
      },
    ],
    secondaryActions,
    otherActions,
  }
}
